import * as React from 'react';
import { IMAGE_PATH } from 'util/util';
import './InputText.css';

export interface IInputTextProps {
  error: string;
  id: string;
  // TODO Delete image and imageFocused
  icon?: string;
  maxLength?: number;
  name: string;
  value: string;
  required: boolean;
  type: string;
  isError: boolean;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onClick?(event: any): void;
}

export const ICO_USER_CIRCLE = 'user-circle';
export const ICO_BALANCE_SCALE = 'balance-scale';
export const ICO_BARCODE = 'barcode';
export const ICO_CARET_DOWN = 'caret-down';
export const ICO_CARET_UP = 'caret-up';
export const ICO_CHECKBOX_CHECKED = 'checkbox checked';
export const ICO_CHECKBOX_UNCHECK = 'checkbox uncheck';
export const ICO_CHEVRON_RIGHT = 'chevron-right';
export const ICO_CLOCK = 'clock';
export const ICO_COG = 'cog';
export const ICO_DESKTOP = 'desktop';
export const ICO_DNA = 'dna';
export const ICO_ENVELOPE = 'envelope';
export const ICO_FONT = 'font';
export const ICO_KEY = 'key';
export const ICO_LEVEL_DOWN_ALT = 'level-down-alt';
export const ICO_LEVEL_UP_ALT = 'level-up-alt';
export const ICO_NUMERIC = 'numeric';
export const ICO_PENCIL_ALT = 'pencil-alt';
export const ICO_PHONE = 'phone';
export const ICO_SORT_NUMERIC_UP = 'sort-numeric-up';
export const ICO_STOPWATCH = 'stopwatch';


interface IInputState {
  focused: boolean;
}

class InputText extends React.Component<IInputTextProps, IInputState> {

  public constructor(props: IInputTextProps) {
    super(props);
    this.state = { focused: false };
  }

  public onFocus(event: React.FocusEvent<HTMLInputElement>) {
    this.setState({ focused: true })
  }

  public onBlur(event: any) {
    this.setState({ focused: false })
  }

  public onChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ focused: this.state.focused });
  }


  public render() {
    const { name, isError, type, required, onChange, onClick } = this.props;

    const maxLength = this.props.maxLength || 15;


    return (
      <div className="input" style={{ display: "flex", flexDirection: "row" }}>
        <div className={`inputIcoDiv ${this.props.icon}`} />
        <div className="inputTextDiv">
          <div className="group">
            <input type={type} required={required} name={this.props.name} id={this.props.id} value={this.props.value} onChange={onChange || this.onChange}
              maxLength={maxLength}
              onFocus={this.onFocus.bind(this, this.state)}
              onBlur={this.onBlur.bind(this, this.state)}
              onClick={onClick}
              autoCapitalize="false" autoCorrect="false" autoComplete="false" />
            <span className="highlight" />
            <span className="bar" />
            <label>{name}</label>

            {// Error div
              isError &&
              <div className="inputError">
                <div>
                  <span >{this.props.error}</span>
                </div>
                <div>
                  <img src={IMAGE_PATH + 'error_exclamation-circle@3x.png'} />
                </div>
              </div>
            }
          </div>
        </div>
      </div >

    );
  }
}

export default InputText;


// WEBPACK FOOTER //
// ./src/components/InputText.tsx